import prjtaskActionTypes from "./prjtasks.types";

export const setPrjTasks = (prjtasks) => ({
  type: prjtaskActionTypes.SET_PRJTASKS,
  payload: prjtasks,
});
